<template>
    <div v-if="showPopup === true">
        <pop-up-modal-content
            :maxWidth="settings.max_width"
            :maxHeight="settings.max_height"
            :backgroundColor="settings.background_color"
            :justifyContentPopUp="settings.justify_content"
            :alignItemsPopUp="settings.align_items"
            :marginPopUp="settings.margin"
            :paddingPopUpBody="settings.body.padding"
            :overflowBodyPopUp="settings.body.overflow"
        >
            <div
                class="modal show modal-cart"
                style="opacity: 1"
                tabindex="-1"
                role="dialog"
                id="modal-pop-up-cart"
                aria-labelledby="modal-pop-up-cart"
                aria-hidden="true"
            >
                <div class="modal-dialog" role="document" @click="closeModal()">
                    <div class="modal-content">
                        <i class="fas fa-times" @click="closeModal()"></i>
                        <div class="modal-body">
                            <a :href="pop_up.link" target="_blank" @click="pop_up.link ? closeModal() : $event.preventDefault()">
                                <img
                                    :src="
                                        $pathFilesSystem + '/' + pop_up.image_path
                                    "
                                    :alt="pop_up.name"
                                    loading="lazy"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </pop-up-modal-content>
    </div>
</template>

<script>
import { CPopUpModalContent } from "../Styles/PopUp/styled";
import * as SessionStorageService from "../../services/SessionStorageService";

export default {
    name: "PopUpCart",
    props: {
        pop_up: { required: true },
        set: { required: true },
        show_popup: { required: true }
    },
    components: {
        "pop-up-modal-content": CPopUpModalContent
    },
    data() {
        return {
            settings: {
                max_width: this.set?.max_width ?? "600px",
                max_height: "calc(100vh - 80px)",
                background_color: this.set?.background_color ?? "#ffffff",
                justify_content: "center",
                align_items: "center",
                margin: "0 auto",
                body: {
                    padding: "0px",
                    overflow: "auto"
                }
            },
            showPopup: false,
            isNavigating: false,
            isReloading: false
        };
    },
    methods: {
        handleMouseOut(event) {
            if (this.isNavigating) return;
            if (event.clientY <= 0 && !event.relatedTarget) {
                this.showPopupIfNotShown();
            }
        },
        handleBeforeUnload() {
            if (!this.isNavigating || this.isReloading) {
                this.showPopupIfNotShown();
            }
        },
        handleKeydown(event) {
            if (event.key === "F5" || (event.ctrlKey && event.key === "r")) {
                this.isReloading = true;
            }
    },
        showPopupIfNotShown() {
            const key = "popup-cart-" + this.pop_up?.id;
            const getKey = SessionStorageService.get(key);

            if (!getKey?.showed) {
                this.showPopup = true;
            }
        },
        closeModal() {
            this.showPopup = false;
            const key = "popup-cart-" + this.pop_up?.id;
            SessionStorageService.set(key, { showed: true });
        },
        handleNavigationStart() {
            this.isNavigating = true;
        },
        handleNavigationEnd() {
            this.isNavigating = false;
        }
    },
    mounted() {
        document.addEventListener("mouseout", this.handleMouseOut);
        window.addEventListener("beforeunload", this.handleBeforeUnload);

        document.addEventListener("keydown", this.handleKeydown);
        document.querySelectorAll('a, button').forEach((element) => {
            element.addEventListener('click', this.handleNavigationStart);
        });
    },
    beforeDestroy() {
        document.removeEventListener("mouseout", this.handleMouseOut);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);

        document.removeEventListener("keydown", this.handleKeydown);
        document.querySelectorAll('a, button').forEach((element) => {
            element.removeEventListener('click', this.handleNavigationStart);
        });
    }
};
</script>

<style scoped>
.modal-cart {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 20px !important;
}

.modal-dialog {
    margin: 0 auto !important;
    max-width: calc(100vw - 40px) !important;
}

.modal-content {
    max-height: calc(100vh - 80px) !important;
}

.modal-body {
    max-height: calc(100vh - 80px);
    overflow: auto;
}

.modal-body,
.modal-body > a {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-body > a {
    width: 100%;
}

img {
    width: auto;
    height: auto;
    max-width: min(100%, calc(100vw - 60px));
    max-height: calc(100vh - 96px);
    object-fit: contain;
    display: block;
}
</style>
